<template>
	<div  class="wrapperddiv">
			<el-card class="box-card">
				<el-row type="flex" justify="end">
					<el-button-group>
						<el-button type="danger" @click="delSelectDialogVisible=true">区间批量删除</el-button>
								<el-button type="success" @click="checkFcl">海运整箱港口匹配</el-button>
					</el-button-group>
					<el-upload class="upload-demo" action="" :on-change="handleChange" :show-file-list="false"
						:auto-upload="false">
						<el-button type="primary">导入excel文件</el-button>
					</el-upload>
					<el-button-group>
						<el-button type="warning" @click="addPrice" :disabled="addButtonDisabled">加价</el-button>
					<!-- 	<el-button type="primary" @click="exportTableData">导出表格数据</el-button>
						<el-button type="primary" @click="exportSelectData">导出选中的行数据</el-button> -->
					</el-button-group>
				</el-row>
				<el-divider></el-divider>
				<el-row :gutter="20">
					<el-col :span="2">
						<el-button type="text" style="color: black;">起运港:</el-button>
					</el-col>
					<el-col :span="6">
						<el-select v-model="queryInfo.pol" filterable placeholder="请选择" clearable>
							<el-option v-for="item in polList" :key="item.pol" :label="item.pol" :value="item.pol">
							</el-option>
						</el-select>
					</el-col>
					<el-col :span="2">
						<el-button type="text" style="color: black;">目的港:</el-button>
					</el-col>
					<el-col :span="6">
						<el-select v-model="queryInfo.pod" filterable placeholder="请选择" clearable>
							<el-option v-for="item in podList" :key="item.pod" :label="item.pod" :value="item.pod">
							</el-option>
						</el-select>
					</el-col>
					<el-col :span="2">
						<el-button type="text" style="color: black;">船公司:</el-button>
					</el-col>
					<el-col :span="6">
						<el-select v-model="queryInfo.carrier" filterable placeholder="请选择" clearable>
							<el-option v-for="item in carrierList" :key="item.carrier" :label="item.carrier"
								:value="item.carrier">
							</el-option>
						</el-select>
					</el-col>
				</el-row>
				<el-row :gutter="20" style="margin-top: 20px;">
					<el-col :span="2">
						<el-button type="text" style="color: black;">失效日:</el-button>
					</el-col>
					<el-col :span="8">
						<el-date-picker v-model="queryInfo.Sxvalue" type="datetimerange" :picker-options="pickerOptions"
							range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right"
							unlink-panels >
						</el-date-picker>
					</el-col>
					<el-col :span="2">
						<el-button type="primary" @click="this.initListFn">查询</el-button>
					</el-col>
				</el-row>
				<el-divider></el-divider>
				<div slot="header" class="clearfix header-box">
					<span>海运整箱数据库</span>
				</div>
				<!-- 表格区域 -->
				<el-table 
				v-loading="loading" 
				element-loading-text="拼命加载中" 
				element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(0, 0, 0, 0.8)" 
				style="width: 100%" :data="dataList" 
				border 
				stripe
				ref="tableDataRef" 
				row-key="id"
				:header-cell-style="{ 'background':'#E9E9E9','color':'#000000' }"
				@selection-change="handleSelectionChange"
					>
					<el-table-column type="selection" :reserve-selection="true" width="55">
					</el-table-column>
					<el-table-column label="序号" type="index">
					</el-table-column>
					<el-table-column label="ID"  prop="id">
					</el-table-column>
					<el-table-column label="起运港" prop="pol" width="150px"></el-table-column>
					<el-table-column label="目的港" prop="pod" width="150px"></el-table-column>
					<el-table-column label="目的港港区" prop="destinationdock" width="150px"></el-table-column>
					<el-table-column label="船期" prop="sale_state" width="150px"></el-table-column>
					<el-table-column label="船公司" prop="carrier" width="150px"></el-table-column>
					<el-table-column label="20GP(T0)" prop="20GP_T0"></el-table-column>
					<el-table-column label="40GP(T0)" prop="40GP_T0"></el-table-column>
					<el-table-column label="40HQ(T0)" prop="40HQ_T0"></el-table-column>
					<el-table-column label="20GP(T1)" prop="20GP_T1"></el-table-column>
					<el-table-column label="40GP(T1)" prop="40GP_T1"></el-table-column>
					<el-table-column label="40HQ(T1)" prop="40HQ_T1"></el-table-column>
					<el-table-column label="20GP(T2)" prop="20GP_T2"></el-table-column>
					<el-table-column label="40GP(T2)" prop="40GP_T2"></el-table-column>
					<el-table-column label="40HQ(T2)" prop="40HQ_T2"></el-table-column>
					<el-table-column label="订舱费" prop="booking_fee" width="150px"></el-table-column>
					<el-table-column label="THC" prop="thc" width="150px"></el-table-column>
					<el-table-column label="铅封" prop="seal" width="150px"></el-table-column>
					<el-table-column label="VGM" prop="vgm" width="150px"></el-table-column>
					<el-table-column label="EIR" prop="eir" width="150px"></el-table-column>
					<el-table-column label="文件费" prop="doc" width="150px"></el-table-column>
					<el-table-column label="舱单费" prop="manifest" width="150px"></el-table-column>
					<el-table-column label="中转港" prop="via" width="150px"></el-table-column>
					<el-table-column label="预计航程" prop="t_t" width="150px"></el-table-column>
					<el-table-column label="起运码头" prop="dock" width="150px"></el-table-column>
					<el-table-column label="生效日" prop="valid_fm" width="150px">
						<template slot-scope="scope">
							{{scope.row.valid_fm | fmtdate}}
						</template>
					</el-table-column>
					<el-table-column label="失效日" prop="valid_to" width="150px">
						<template slot-scope="scope">
							{{scope.row.valid_to | fmtdate}}
						</template>
					</el-table-column>
					<el-table-column label="暂停接货" prop="yes_no" width="150px">
					</el-table-column>
					<el-table-column label="备注" prop="remark" width="150px" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column label="备注1" prop="weight_limit" width="150px" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column label="备注2" prop="other" width="150px" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column label="备注3" prop="remark3" width="150px" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column label="备注4" prop="remark4" width="150px" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column label="总备注" prop="remarkconcat" width="150px" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column label="更新日期" prop="update_time"  width="150px"></el-table-column>	
					<el-table-column label="操作" width="150px" fixed="right">
						<template slot-scope="scope" >
							<el-button type="primary" size="mini" @click="updateFn(scope.row.id)">修改</el-button>
							<el-button type="danger" size="mini" @click="removeFn(scope.row.id)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
				<!-- 分页区域 -->
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="queryInfo.pagenum" :page-sizes="[10,50,100,200]"
					:page-size="queryInfo.pagesize" layout="total, sizes, prev, pager, next, jumper" :total="total">
				</el-pagination>
			</el-card>

		<el-dialog :lock-scroll="false" title="加价" :visible.sync="addPriceDialogVisible" width="90%"
			@close="addPriceDialogClosed" :close-on-click-modal="false" top="2vh">
			<!-- 内容主体区域 -->
			<el-form :rules="addPriceFormRules" ref="addPriceFormRef" :model="addPriceForm" label-width="100px">
				<!-- T0 -->
				<el-row :gutter="20">
					<el-col :span="8">
						<el-form-item label="20GP(T0)" prop="20GP_T0">
							<el-input v-model="addPriceForm['20GP_T0']" type="number"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="40GP(T0)" prop="40GP_T0">
							<el-input v-model="addPriceForm['40GP_T0']" type="number" ></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="40HQ(T0)" prop="40HQ_T0">
							<el-input v-model="addPriceForm['40HQ_T0']" type="number"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<!-- T1 -->
				<el-row :gutter="20">
					<el-col :span="8">
						<el-form-item label="20GP(T1)" prop="20GP_T1">
							<el-input v-model="addPriceForm['20GP_T1']" type="number" ></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="40GP(T1)" prop="40GP_T1">
							<el-input v-model="addPriceForm['40GP_T1']" type="number" ></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="40HQ(T1)" prop="40HQ_T1">
							<el-input v-model="addPriceForm['40HQ_T1']" type="number" ></el-input>
						</el-form-item>
					</el-col>
				</el-row>
					<!-- T2 -->
				<el-row :gutter="20">
					<el-col :span="8">
					
						<el-form-item label="20GP(T2)" prop="20GP_T2">
							<el-input v-model.lazy="addPriceForm['20GP_T2']"  type="number"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="40GP(T2)" prop="40GP_T2">
							<el-input v-model="addPriceForm['40GP_T2']" type="number" ></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="40HQ(T2)" prop="40HQ_T2">
							<el-input v-model="addPriceForm['40HQ_T2']" type="number" ></el-input>
						</el-form-item>
					</el-col>
				</el-row>
            
      <el-table 
	  height="270px"
	  v-loading="loading" 
	  element-loading-text="拼命加载中" 
	  element-loading-spinner="el-icon-loading"
	  element-loading-background="rgba(0, 0, 0, 0.8)" 
	  style="width: 100%" 
	  :data="selectionList" 
	  border 
	  stripe
	  ref="tableDataAddPriceRef" 
	  row-key="id" 
	  :header-cell-style="{ 'background':'#E9E9E9','color':'#000000' }">
					<el-table-column label="序号" type="index">
					</el-table-column>
					<el-table-column label="ID" prop="id">
					</el-table-column>
					<el-table-column label="起运港" prop="pol" width="150px"></el-table-column>
					<el-table-column label="目的港" prop="pod" width="150px"></el-table-column>
					<el-table-column label="目的港港区" prop="destinationdock" width="150px"></el-table-column>
					<el-table-column label="船期" prop="sale_state" width="150px"></el-table-column>
					<el-table-column label="船公司" prop="carrier" width="150px"></el-table-column>
					<el-table-column label="20GP(T0)" prop="20GP_T0">
						<template slot-scope="scope">
							<span style="color: red">{{      
				priceView == false	? Number(scope.row['20GP_T0']) + Number(addPriceForm['20GP_T0']) : Number(scope.row['20GP_T0'])
								}}</span>
						</template>
					</el-table-column>
					<el-table-column label="40GP(T0)" prop="40GP_T0">
						<template slot-scope="scope">
							<span style="color: red">{{priceView == false ? Number(scope.row['40GP_T0']) + Number(addPriceForm['40GP_T0']) : Number(scope.row['40GP_T0']) }}</span>
						
						</template>
					</el-table-column>
					<el-table-column label="40HQ(T0)" prop="40HQ_T0">
						<template slot-scope="scope">
							<span style="color: red">{{priceView == false ? Number(scope.row['40HQ_T0']) + Number(addPriceForm['40HQ_T0']) : Number(scope.row['40HQ_T0']) }}</span>
					
						</template>
					</el-table-column>
					<el-table-column label="20GP(T1)" prop="20GP_T1">
						<template slot-scope="scope">
							<span style="color: red">{{priceView == false ?  Number(scope.row['20GP_T1']) + Number(addPriceForm['20GP_T1']) :  Number(scope.row['20GP_T1']) }}</span>
					
						</template>
					</el-table-column>
					<el-table-column label="40GP(T1)" prop="40GP_T1">
						<template slot-scope="scope">
							<span style="color: red">{{ priceView == false ?  Number(scope.row['40GP_T1']) + Number(addPriceForm['40GP_T1']) :  Number(scope.row['40GP_T1'])  }}</span>
							
						</template>
					</el-table-column>
					<el-table-column label="40HQ(T1)" prop="40HQ_T1">
						<template slot-scope="scope">
							<span style="color: red">{{ priceView == false ? Number(scope.row['40HQ_T1']) + Number(addPriceForm['40HQ_T1']) :  Number(scope.row['40HQ_T1'])  }}</span>
							
						</template>
					</el-table-column>
					<el-table-column label="20GP(T2)" prop="20GP_T2">
						<template slot-scope="scope">
							<span style="color: red">{{ priceView == false ? Number(scope.row['20GP_T2']) + Number(addPriceForm['20GP_T2']) :  Number(scope.row['20GP_T2']) }}</span>
						</template>
					</el-table-column>
					<el-table-column label="40GP(T2)" prop="40GP_T2">
						<template slot-scope="scope">
							<span style="color: red">{{ priceView == false ? Number(scope.row['40GP_T2']) + Number(addPriceForm['40GP_T2']) :  Number(scope.row['40GP_T2']) }}</span>
							
						</template>
					</el-table-column>
					<el-table-column label="40HQ(T2)" prop="40HQ_T2">
						<template slot-scope="scope">
							<span style="color: red">{{ priceView == false ? Number(scope.row['40HQ_T2']) + Number(addPriceForm['40HQ_T2']) :  Number(scope.row['40HQ_T2'])}}</span>	
						</template>
					</el-table-column>
					<el-table-column label="订舱费" prop="booking_fee" width="150px"></el-table-column>
					<el-table-column label="THC" prop="thc" width="150px"></el-table-column>
					<el-table-column label="铅封" prop="seal" width="150px"></el-table-column>
					<el-table-column label="VGM" prop="vgm" width="150px"></el-table-column>
					<el-table-column label="EIR" prop="eir" width="150px"></el-table-column>
					<el-table-column label="文件费" prop="doc" width="150px"></el-table-column>
					<el-table-column label="舱单费" prop="manifest" width="150px"></el-table-column>
					<el-table-column label="中转港" prop="via" width="150px"></el-table-column>
					<el-table-column label="预计航程" prop="t_t" width="150px"></el-table-column>
					<el-table-column label="起运码头" prop="dock" width="150px"></el-table-column>
					<el-table-column label="生效日" prop="valid_fm" width="150px">
						<template slot-scope="scope">
							{{scope.row.valid_fm | fmtdate}}
						</template>
					</el-table-column>
					<el-table-column label="失效日" prop="valid_to" width="150px">
						<template slot-scope="scope">
							{{scope.row.valid_to | fmtdate}}
						</template>
					</el-table-column>
					<el-table-column label="备注" prop="remark"></el-table-column>
				</el-table>



			</el-form>
			<!-- 底部区域 -->
			<span slot="footer" class="dialog-footer">
				<el-button @click="addPriceDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="addPriceConfirm" :disabled="addPriceConfirmDisabled">确 定</el-button>
			</span>
		</el-dialog>
		
		
		<el-dialog 
		:lock-scroll="false" 
		title="区间批量删除" 
		:visible.sync="delSelectDialogVisible" 
		width="50%"
		@close="delSelectDialogClosed" 
		:close-on-click-modal="false">
			<el-form 
			ref="delSelectFormRef" 
			:model="delSelectForm" 
			label-width="100px">
			<el-row :gutter="20">
				<el-col :span="2">
					<el-button type="text" style="color: black;">选择ID区间:</el-button>
				</el-col>
				<el-col :span="9">
					<el-form-item  prop="start">
						<el-input v-model="delSelectForm.start"  type="number"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="1">
					<el-button type="text" style="color: black;">到</el-button>
				</el-col>
				<el-col :span="9"  style="margin-left: -95px;">
					<el-form-item  prop="end">
						<el-input v-model="delSelectForm.end" type="number" ></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
					<el-button @click="delSelectDialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="delSelectConfirm">确 定</el-button>
				</span>
			</el-dialog>
			<!-- 修改 -->
		<el-dialog
		:lock-scroll="false" 
		title="修改" 
		:visible.sync="editDialogVisible" 
		width="90%"
		@close="editDialogClosed" 
		:close-on-click-modal="false"
		top="5vh"
		>
			<el-form 
			ref="editFormRef" 
			:model="editForm" 
			label-width="100px">
			<el-row :gutter="20">
				<el-col :span="6">
		     <el-form-item label="起运港" prop="pol">
		       <el-input v-model="editForm.pol"></el-input>
		     </el-form-item>
			  </el-col>
			  <el-col :span="6">
			  <el-form-item label="目的港" prop="pod">
			    <el-input v-model="editForm.pod"></el-input>
			  </el-form-item>
			   </el-col>
			   <el-col :span="6">
			   <el-form-item label="目的港港区" prop="destinationdock">
			     <el-input v-model="editForm.destinationdock"></el-input>
			   </el-form-item>
			    </el-col>
				<el-col :span="6">
				<el-form-item label="船期" prop="sale_state">
				  <el-input v-model="editForm.sale_state"></el-input>
				</el-form-item>
				 </el-col>
			</el-row>
			
			<el-row :gutter="20">
				<el-col :span="6">
				<el-form-item label="船公司" prop="carrier">
				  <el-input v-model="editForm.carrier"></el-input>
				</el-form-item>
				 </el-col>
				<el-col :span="6">
			 <el-form-item label="20GP(T0)" prop="20GP_T0">
			   <el-input v-model="editForm['20GP_T0']"></el-input>
			 </el-form-item>
			  </el-col>
			  <el-col :span="6">
			  <el-form-item label="40GP(T0)" prop="40GP_T0">
			    <el-input v-model="editForm['40GP_T0']"></el-input>
			  </el-form-item>
			   </el-col>
			   <el-col :span="6">
			   <el-form-item label="40HQ(T0)" prop="40HQ_T0">
			     <el-input v-model="editForm['40HQ_T0']"></el-input>
			   </el-form-item>
			    </el-col>
			</el-row>
			
			<el-row :gutter="20">
				<el-col :span="6">
			 <el-form-item label="20GP(T1)" prop="20GP_T1">
			   <el-input v-model="editForm['20GP_T1']"></el-input>
			 </el-form-item>
			  </el-col>
			  <el-col :span="6">
			  <el-form-item label="40GP(T1)" prop="40GP_T1">
			    <el-input v-model="editForm['40GP_T1']"></el-input>
			  </el-form-item>
			   </el-col>
			   <el-col :span="6">
			   <el-form-item label="40HQ(T1)" prop="40HQ_T1">
			     <el-input v-model="editForm['40HQ_T1']"></el-input>
			   </el-form-item>
			    </el-col>
				<el-col :span="6">
				<el-form-item label="20GP(T2)" prop="20GP_T2">
				  <el-input v-model="editForm['20GP_T2']"></el-input>
				</el-form-item>
				 </el-col>
			</el-row>
			
			<el-row :gutter="20">
			  <el-col :span="6">
			  <el-form-item label="40GP(T2)" prop="40GP_T2">
			    <el-input v-model="editForm['40GP_T2']"></el-input>
			  </el-form-item>
			   </el-col>
			   <el-col :span="6">
			   <el-form-item label="40HQ(T2)" prop="40HQ_T2">
			     <el-input v-model="editForm['40HQ_T2']"></el-input>
			   </el-form-item>
			    </el-col>
				<el-col :span="6">
				<el-form-item label="订舱费" prop="booking_fee">
				  <el-input v-model="editForm.booking_fee"></el-input>
				</el-form-item>
				 </el-col>
				 <el-col :span="6">
				 <el-form-item label="THC" prop="thc">
				   <el-input v-model="editForm.thc"></el-input>
				 </el-form-item>
				  </el-col>
			</el-row>
			
			<el-row :gutter="20">
			  <el-col :span="6">
			  <el-form-item label="铅封" prop="seal">
			    <el-input v-model="editForm.seal"></el-input>
			  </el-form-item>
			   </el-col>
			   <el-col :span="6">
			   <el-form-item label="VGM" prop="vgm">
			     <el-input v-model="editForm.vgm"></el-input>
			   </el-form-item>
			    </el-col>
				<el-col :span="6">
				<el-form-item label="EIR" prop="eir">
				  <el-input v-model="editForm.eir"></el-input>
				</el-form-item>
				 </el-col>
				 <el-col :span="6">
				 <el-form-item label="文件费" prop="doc">
				   <el-input v-model="editForm.doc"></el-input>
				 </el-form-item>
				  </el-col>
			</el-row>
			
			<el-row :gutter="20">
			  <el-col :span="6">
			  <el-form-item label="舱单费" prop="manifest">
			    <el-input v-model="editForm.manifest"></el-input>
			  </el-form-item>
			   </el-col>
			   <el-col :span="6">
			   <el-form-item label="中转港" prop="via">
			     <el-input v-model="editForm.via"></el-input>
			   </el-form-item>
			    </el-col>
				<el-col :span="6">
				<el-form-item label="预计航程" prop="t_t">
				  <el-input v-model="editForm.t_t"></el-input>
				</el-form-item>
				 </el-col>
				 <el-col :span="6">
				 <el-form-item label="起运码头" prop="dock">
				   <el-input v-model="editForm.dock"></el-input>
				 </el-form-item>
				  </el-col>
			</el-row>
			
			<el-row :gutter="20">
			  <el-col :span="6">
			  <el-form-item label="生效日" prop="valid_fm">
			  	 <el-date-picker
			  	      v-model="editForm.valid_fm"
			  	      type="datetime"
			  	      placeholder="选择日期时间"
			  	      default-time="00:00:00">
			  	    </el-date-picker>
			  </el-form-item>
			   </el-col>
			   <el-col :span="6">
			   <el-form-item label="失效日" prop="valid_to">
			   	 <el-date-picker
			   	      v-model="editForm.valid_to"
			   	      type="datetime"
			   	      placeholder="选择日期时间"
			   	      default-time="00:00:00">
			   	    </el-date-picker>
			   </el-form-item>
			    </el-col>
				 <el-col :span="12">
				 <el-form-item label="备注" prop="remark">
				   <el-input v-model="editForm.remark"  type="textarea"></el-input>
				 </el-form-item>
				  </el-col>
			</el-row>
			
			
			
			
			
			
			</el-form>
			<span slot="footer" class="dialog-footer">
					<el-button @click="editDialogVisible = false">取消</el-button>
					<el-button type="primary" @click="editConfirm">确定修改</el-button>
				</span>
			</el-dialog>	
			
		<el-dialog
		  title="以下海运整箱港口数据未匹配上"
		  :visible.sync="dialogVisibleFcl"
		  width="50%"
		  :close-on-click-modal="false"
		 >
		 <span style="font-weight: bold;">共{{this.FclDataList.length}}条</span>
		 <div 
		 v-for="item in FclDataList"
		 :key="item.pod"
		 >
		 <div style="display: flex;padding: 10px;">
			 <span>港口:{{item.pod}}</span>
		 </div>
			 
		 </div>
		  <span slot="footer" class="dialog-footer">
		    <el-button type="primary" @click="dialogVisibleFcl = false">确 定</el-button>
		  </span>
		</el-dialog>	

	</div>
</template>

<script>
	//表格导入依赖
	import XLSX from 'xlsx'
	import moment from 'moment';
	export default {
		data() {
			return {
				addPriceConfirmDisabled:false,
				priceView:false,
				podList: [],
				polList: [],
				carrierList: [],
				loading: false,
				fileContent: '',
				file: '',
				data: '',
				//选中行导出的值
				selectionList: [],
				multipleSelection: [],
				queryInfo: {
					carrier: '',
					Sxvalue: '',
					pol: '',
					pod: '',
					//当前的页数
					pagenum: 1,
					//当前每页显示多少条数据
					pagesize: 10,
				},
				total: 0,
				//日期
				pickerOptions: {
					shortcuts: [{
						text: '最近一周',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近一个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近三个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit('pick', [start, end]);
						}
					}]
				},
				//延时器，防抖，防止用户频繁请求
				timer: null,
				dataList: [], // 数据列表
				//系统加价
				addPriceDialogVisible: false,
				addPriceForm: {
					['20GP_T0']:'',
					['40GP_T0']:'',
					['40HQ_T0']:'',
					['20GP_T1']:'',
					['40GP_T1']:'',
					['40HQ_T1']:'',
					['20GP_T2']:'',
					['40GP_T2']:'',
					['40HQ_T2']:'',
				},
				addPriceFormRules: {},
				//区间批量删除
				delSelectDialogVisible:false,
				delSelectForm:{
					start:'',
					end:''
				},
				//修改行信息
				editDialogVisible:false,
				editForm:{},
				FclDataList:[],
				dialogVisibleFcl:false,
			}
		},
	computed:{
			addButtonDisabled(){
				if(this.selectionList.length <= 0){
					return true
				}
			}
		},
		created() {
			this.initListFn()
		},
		
		methods: {
			//导出表格数据
			exportTableData() {
				// 获取dom元素（2种方式）
				let table = this.$refs.tableDataRef.$el
				let sheet = XLSX.utils.table_to_sheet(table)
				let book = XLSX.utils.book_new()
				XLSX.utils.book_append_sheet(book, sheet, "sheet1")
				XLSX.writeFile(book, `oceanFreight.xls`)
			},
			//导出行数据
			//监听复选框选中的值
			handleSelectionChange(val) {
				this.selectionList = val
				console.log(this.selectionList)
				let arryVal = val.map((item) => {
					return item.id
				})
				this.multipleSelection = arryVal;
				//console.log(this.multipleSelection)
			},
			exportSelectData() {
				// 对选择的表格数据处理：添加标题
				let arr = this.selectionList.map(item => {
					return {
						ID: item.id,
						起运港: item.pol,
						目的港: item.pod,
						目的港港区: item.destinationdock,
						船期: item.sale_state,
						船公司: item.carrier,
						['20GP(T0)']: item['20GP_T0'],
						['40GP(T0)']: item['40GP_T0'],
						['40HQ(T0)']: item['40HQ_T0'],
						['20GP(T1)']: item['20GP_T1'],
						['40GP(T1)']: item['40GP_T1'],
						['40HQ(T1)']: item['40HQ_T1'],
						['20GP(T2)']: item['20GP_T2'],
						['40GP(T2)']: item['40GP_T2'],
						['40HQ(T2)']: item['40HQ_T2'],
						订舱费: item.booking_fee,
						THC: item.thc,
						铅封: item.seal,
						VGM: item.vgm,
						EIR: item.eir,
						文件费: item.doc,
						舱单费: item.manifest,
						中转港: item.via,
						预计航程: item['t_t'],
						起运码头: item.dock,
						生效日: item.valid_fm,
						失效日: item.valid_to,
						备注: item.remark,




					}
				})
				// 将json数据变为sheet数据
				// json_to_sheet: 将一个由对象组成的数组转成sheet；
				let sheet = XLSX.utils.json_to_sheet(arr)
				// 新建表格
				let book = XLSX.utils.book_new()
				// 在表格中插入一个sheet
				XLSX.utils.book_append_sheet(book, sheet, "sheet1")
				// 通过xlsx的writeFile方法将文件写入
				XLSX.writeFile(book, `oceanFreight.xls`)
			},


			//导入功能*****************************************************
			// 核心部分代码(handleChange 和 importfile)
			handleChange(file, fileList) {
				this.fileContent = file.raw
				const fileName = file.name
				const fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
				if(file.size / 1024 /1024 > 2){
				return	this.$message({
						type: 'warning',
						message: '该文件大小不能超过2MB,请检查ID是否异常溢出！'
					})
				}
				
				
				if (this.fileContent) {
					if (fileType === 'xlsx' || fileType === 'xls') {
						this.importfile(this.fileContent)
					} else {
						this.$message({
							type: 'warning',
							message: '附件格式错误，请重新上传！'
						})
					}
				} else {
					this.$message({
						type: 'warning',
						message: '请上传附件！'
					})
				}
			},
			importfile(obj) {
				const reader = new FileReader()
				const _this = this
				reader.readAsArrayBuffer(obj)
				reader.onload = async function() {
					const buffer = reader.result
					const bytes = new Uint8Array(buffer)
					const length = bytes.byteLength
					let binary = ''
					for (let i = 0; i < length; i++) {
						binary += String.fromCharCode(bytes[i])
					}
					const XLSX = require('xlsx')
					const wb = XLSX.read(binary, {
						type: 'binary',
						cellDates: true
					})
					const outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]])
					this.data = [...outdata]
					const arr = []
					this.data.map(v => {
						const obj = {}
						obj.id = v['ID']
						obj.pol = v['起运港']
						obj.pod = v['目的港']
						obj.destinationdock = v['目的港港区']
						obj.sale_state = v['船期']
						obj.carrier = v['船公司']
						obj['20GP_T0'] = v['20GP(T0)']
						obj['40GP_T0'] = v['40GP(T0)']
						obj['40HQ_T0'] = v['40HQ(T0)']
						obj['20GP_T1'] = v['20GP(T1)']
						obj['40GP_T1'] = v['40GP(T1)']
						obj['40HQ_T1'] = v['40HQ(T1)']
						obj['20GP_T2'] = v['20GP(T2)']
						obj['40GP_T2'] = v['40GP(T2)']
						obj['40HQ_T2'] = v['40HQ(T2)']
						obj.booking_fee = v['订舱费']
						obj.thc = v['THC']
						obj.seal = v['铅封']
						obj.vgm = v['VGM']
						obj.eir = v['EIR']
						obj.doc = v['文件费']
						obj.manifest = v['舱单费']
						obj.via = v['中转港']
						obj['t_t'] = v['预计航程']
						obj.dock = v['起运码头']
						obj.valid_fm = v['生效日'] ==undefined ? undefined : moment(v['生效日']).format('YYYY-MM-DD')
						obj.valid_to = v['失效日']  ==undefined ? undefined :  moment(v['失效日']).format('YYYY-MM-DD')
						obj.yes_no = v['暂停接货']
						obj.remark = v['备注']
						obj.weight_limit = v['备注1']
						obj.other = v['备注2']
						obj.remark3 = v['备注3']
						obj.remark4 = v['备注4']
						obj.update_time =  v['更新日期'] = moment(v['更新日期']).format('YYYY-MM-DD')
						//console.log(obj)
						arr.push(obj)
					})
					//console.log(arr)
					let dateInit = arr.filter((item,index)=>{
					return	item.pod  && (item.valid_fm == 'Invalid date' || item.valid_to == 'Invalid date' ||  item.valid_fm == undefined || item.valid_to == undefined)
						});
					//console.log(dateInit)
					let DateInitId = dateInit.map(item => {return item.id})
					if(dateInit.length>0){
						return _this.$message.error(`ID为${DateInitId}日期错误`)
					}
					// //后端请求数据
					// //这里不能用this，用_this
					//数据格式化数组对象转成(),(),()
					let str = arr.reduce((total, item, index) => {
						//累加三个逗号
						if (index != 0) {
							total += ','
						}
						total += '("' + encodeURIComponent(Object.values(item).join('","')) + '")'
						return total
					}, "")
					// //方法二，以''规则分割
					// let str = arr.reduce((total,item,index)=>{
					// 						 //累加三个逗号
					//     if(index!=0){total+=','}
					//     total+="('"+ encodeURIComponent(Object.values(item).join("','"))  +"')"
					//     return total
					// },'')
					
					
					
					
					let datainfo = {
						infoString: decodeURIComponent(str)
					}

					const {data: res} = await _this.$http.addMoreFcl({data:datainfo})				 
					if (res.status !== 0) {
						return _this.$message.error(res.message)
					}
					   _this.$message.success('导入成功！')
					setTimeout(() => {
						window.location.reload()
					     }, 500);
				}
			},





			changeValue(e) {
				this.queryInfo.pagenum = 1
				clearTimeout(this.timer)
				this.timer = setTimeout(() => {
					this.queryInfo.query = e
					console.log(this.queryInfo.query)
					this.initListFn()

				}, 500)
			},
			// 获取列表；获取下拉数据也获取所有列表数据
			async initListFn() {
				this.loading = true
				//解决日期按钮组件清空了，但是值没清空问题
				if (!this.queryInfo.Sxvalue) {
				  this.queryInfo.Sxvalue = ''
				}
				const {
					data: res
				} = await this.$http.getFclBySea({
					params: this.queryInfo
				})
				if (res.status !== 0) {
					return this.$message.error('获取数据失败!')
				}
				this.dataList = res.data
				this.total = res.total
				this.loading = false
				this.podList = res.pod
				this.polList = res.pol
				this.carrierList = res.carrier
			},
			//监听pagesize改变的事件
			handleSizeChange(newSize) {
				this.queryInfo.pagesize = newSize
				this.initListFn()
			},
			//监听页面值改变的事件
			handleCurrentChange(newPage) {
				this.queryInfo.pagenum = newPage
				this.initListFn()
			},

			addPrice() {
				this.addPriceDialogVisible = true
			},
		async addPriceConfirm(){
		// console.log(this.addPriceForm)
		if(this.addPriceForm['20GP_T0'] == '' && this.addPriceForm['40GP_T0'] =='' && this.addPriceForm['40HQ_T0'] =='' && this.addPriceForm['20GP_T1'] =='' && this.addPriceForm['40GP_T1'] =='' && this.addPriceForm['40HQ_T1'] =='' && this.addPriceForm['20GP_T2'] =='' && this.addPriceForm['40GP_T2'] =='' && this.addPriceForm['40HQ_T2'] =='' ){
			return this.$message.error('请选择要更改的价格!')
		}
				let arr = this.selectionList.map(item=>{
					item['20GP_T0'] = item['20GP_T0']*1 + this.addPriceForm['20GP_T0']*1,
					item['40GP_T0'] = item['40GP_T0']*1 + this.addPriceForm['40GP_T0']*1,
					item['40HQ_T0'] = item['40HQ_T0']*1 + this.addPriceForm['40HQ_T0']*1,
					item['20GP_T1'] = item['20GP_T1']*1 + this.addPriceForm['20GP_T1']*1,
					item['40GP_T1'] = item['40GP_T1']*1 + this.addPriceForm['40GP_T1']*1,
					item['40HQ_T1'] = item['40HQ_T1']*1 + this.addPriceForm['40HQ_T1']*1,
					item['20GP_T2'] = item['20GP_T2']*1 + this.addPriceForm['20GP_T2']*1,
					item['40GP_T2'] = item['40GP_T2']*1 + this.addPriceForm['40GP_T2']*1,
					item['40HQ_T2'] = item['40HQ_T2']*1 + this.addPriceForm['40HQ_T2']*1
					return item
				})	
				this.priceView = true
			console.log(arr)
			
	let str = arr.reduce((total, item, index) => {
		//累加三个逗号
		if (index != 0) {
			total += ','
		}
		total += '("' + encodeURIComponent(Object.values(item).join('","')) + '")'
		return total
	}, "")
	// //方法二，以''规则分割
	// let str = arr.reduce((total,item,index)=>{
	// 						 //累加三个逗号
	//     if(index!=0){total+=','}
	//     total+="('"+ encodeURIComponent(Object.values(item).join("','"))  +"')"
	//     return total
	// },'')
	
	
	
	let datainfo = {
		infoString: decodeURIComponent(str)
	}
	const {data: res} = await this.$http.addMoreFcl({data:datainfo})
	if (res.status !== 0) {
		return this.$message.error('修改价格失败!')
	}
	  
	window.location.reload()
	this.$message.success('修改价格成功！')
	},
			addPriceDialogClosed() {
            this.selectionList=[]
			 this.$refs.tableDataRef.clearSelection();
			this.$refs.addPriceFormRef.resetFields()
			},


async updateFn(id){
	const {data:res} = await this.$http.byIdFcl(id)
	if (res.status !==0){
		return this.$message.error('获取数据失败!')
	}
	this.editForm = res.data
	this.editDialogVisible = true
},
//修改信息
async editConfirm(){
	const {data:res} = await this.$http.editFcl(this.editForm)
	if (res.status !==0){
		return this.$message.error('修改失败!')
		}
		this.$message.success('修改成功!')
		this.editDialogVisible = false
		this.initListFn()
},
editDialogClosed(){
	this.$refs.editFormRef.resetFields()
},











			// 删除
			async removeFn(id) {
				const confirmResult = await this.$confirm('此操作将删除这条数据是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					 lockScroll:false
				}).catch(err => err)
				if (confirmResult !== 'confirm') {
					return this.$message.info('已取消删除')
				}
				const {
					data: res
				} = await this.$http.delFclBySea(id)
				if (res.status !== 0) return this.$message.error('删除失败！')
				this.$message.success('删除成功！')
				// 重新请求列表数据
				this.initListFn()

			},
			
			
			//区间删除
		async delSelectConfirm(){
			if (this.delSelectForm.start == '' && this.delSelectForm.end == '') {
				return this.$message.warning('请填写ID！')
			}
			const confirmResult = await this.$confirm('注意！此操作将批量删除, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				lockScroll:false
			}).catch(err => err)
			//如果确认删除，则返回值为字符串 confirm
			console.log(confirmResult)
			if (confirmResult !== 'confirm') {
				return this.$message.info('已取消删除')
			}
			let idString = `${this.delSelectForm.start},${this.delSelectForm.end}`
			const {
				data: res
			} = await this.$http.delBatchFclBySea({
				id: idString
			})
			if (res.status !== 0) {
				return this.$message.error('批量删除失败!')
			}
			this.$message.success('批量删除成功!')
			this.initListFn()
			this.delSelectDialogVisible = false
			},
			delSelectDialogClosed(){
				this.$refs.delSelectFormRef.resetFields()
			},
			async	checkFcl(){
					const { data: res } = await this.$http.getCheckPortFcl()
					if (res.status !== 0) {
					 return this.$message.error('查询失败')
					}
					//港口数据
					let portList = res.portList
					//整箱港口数据
					let fclList = res.fclList
					// let resList = fclList.filter(item => !portList.some(ele=> ele.portname.replace(/\s/g,"").toLowerCase() === (item.pod.includes('/')== true ? item.pod.split('/')[0].replace(/\s/g,"").toLowerCase() : (item.pod.includes(',')== true ?  item.pod.split(',')[0].replace(/\s/g,"").toLowerCase() : item.pod.replace(/\s/g,"").toLowerCase()))
					// ))
					
					
					let resList =fclList.filter(item => !portList.some(ele=> item.pod.replace(/\s/g,"").toLowerCase().indexOf(ele.portname.replace(/\s/g,"").toLowerCase()) > -1
						))	
			
					this.FclDataList = resList
					console.log(this.FclDataList)
					this.dialogVisibleFcl = true
				},
		}
	}
</script>

<style lang="less" scoped>
	.header-box {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	@media screen and (min-width: 1280px) {
		.wrapperddiv{
			height: 100vh;
			width: 100%;
			display:inline-block;
		} 
	}
	
	//手机端
	@media screen and (max-width: 1280px) {
		.wrapperddiv{
			height: 100%;
			width: 100%;
			display:inline-block;
		} 
	}
</style>